<template>
  <v-container>
    <v-row>
      <v-col xs="12" md="4">
        <v-list rounded>
          <v-subheader>Za davatelje usluga</v-subheader>
          <v-list-item-group v-model="active_num" color="#084776">
            <v-list-item v-for="(item, i) in items" :key="i" @click="active(item.num)">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col xs="12" md="8">
        <div v-for="(item, i) in tekstovi" :key="i" v-if="active_num == item.num">
          <h2 style="color: #084776" >{{item.title}}</h2>
          <br />
          <p v-html="item.txt"></p>
        </div>
        <div v-if="active_num == 1">
          <v-expansion-panels>
            <v-expansion-panel v-for="(item,i) in pitanja" :key="i">
              <v-expansion-panel-header style="color: #084776">{{item.title}}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-divider></v-divider>
                  <v-card-text style="color: #000" v-html="item.text"></v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <v-fade-transition mode="out-in">
          <router-view></router-view>
        </v-fade-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    item: 0,
    items: [
      { text: "Upute", icon: "fas fa-info-circle", num: 0 },
      {
        text: "Često postavljena pitanja",
        icon: "fas fa-question-circle",
        num: 1
      },
    ],
    active_num: 0,
    tekstovi: [
      {
        num: 0,
        title: "Upute za davatelje usluge",
        txt: `<h3>Tehnički preduvjeti</h3>
            Davatelji eduroam usluge trebaju imati:<br><br>
            <ol>
                <li>Funkcionalnu vezu na Internet.</li>
                <li>Bežičnu mrežu temeljenu na pristupnim uređajima (engl. Access Point) koji podržavaju 802.1x protokol uz WPA2/AES enkripciju i autentikaciju na vanjskom RADIUS poslužitelju.</li>
                <li>RADIUS poslužitelj s odgovarajućom konfiguracijom.</li>
            </ol><br><br>
            <h3>Konfiguriranje u skladu sa eduroam normama</h3>
            Pristupne uređaje i RADIUS poslužitelj potrebno je konfigurirati na sljedeći način:<br><br>
            <ol>
                <li>Pristupni uređaji (Access point) trebaju biti konfigurirani prema sljedećim parametrima:<br>
                    <table>
                        <tr>
                            <td><b>SSID:</b></td>
                            <td>eduroam</td>
                        </tr>
                        <tr>
                            <td><b>Emitiranje SSID-a:</b></td>
                            <td>Da</td>
                        </tr>
                        <tr>
                            <td><b>Sigurnosna zaštita:</b></td>
                            <td>WPA2/AES</td>
                        </tr>
                        <tr>
                            <td><b>EAP (802.1x):</b></td>
                            <td>EAP s potpunom RADIUS autentikacijom</td>
                        </tr>
                        <tr>
                            <td><b>Autentikacija:</b></td>
                            <td>Postaviti autentikaciju putem vanjskog RADIUS poslužitelja (unosom IP adrese i porta, npr.: 192.168.1.1:1812 - auth, 192.168.1.1 - acct)</td>
                        </tr>
                    </table>
                </li>
                <li>Ispravno konfiguriran RADIUS poslužitelj s funkcionalnostima za davatelje usluge (engl. Service providers). Upute za davatelje usluga dane su na stranici: <a href="https://wiki.geant.org/display/H2eduroam/How+to+deploy+eduroam+on-site+or+on+campus#Howtodeployeduroamon-siteoroncampus-eduroamSP" target="_blank" class="link">How to deploy eduroam on-site or on campus</a>.</li>
                <li>Minimalni skup otvorenih mrežnih portova za eduroam korisnike:</li>
                <ul>
                    <li>Standard IPSec VPN: IP protocols 50 (ESP) and 51 (AH) both egress and ingress; UDP/500 (IKE) egress only</li>
                    <li>OpenVPN 2.0: UDP/1194</li>
                    <li>IPv6 Tunnel Broker service: IP protocol 41 ingress and egress</li>
                    <li>IPsec NAT-Traversal UDP/4500</li>
                    <li>Cisco IPSec VPN over UDP/TCP: UDP/TCP 10000</li>
                    <li>PPTP VPN: IP protocol 47 (GRE) ingress and egress; TCP/1723 egress only</li>
                    <li>SSH: TCP/22 egress only</li>
                    <li>HTTP: TCP/80 egress only</li>
                    <li>HTTPS: TCP/443 egress only</li>
                    <li>IMAP2+4: TCP/143 egress only</li>
                    <li>IMAP3: TCP/220 egress only</li>
                    <li>IMAPS: TCP/993 egress only</li>
                    <li>POP: TCP/110 egress only</li>
                    <li>POP3S: TCP/995 egress only</li>
                    <li>Passive (S)FTP: TCP/21 egress only</li>
                    <li>SMTPS: TCP/465 egress only</li>
                    <li>SMTP submit with STARTTLS: TCP/587 egress only</li>
                    <li>RDP: TCP/3389 egress only</li>
                </ul>
            </ol>`
      }
    ],
    pitanja: [
      {
        title: "Što je eduroam?",
        text: `eduroam (edukacijski roaming) omogućuje korisnicima (znanstvenicima, nastavnicima, studentima i drugom osoblju) ustanova sudionica siguran pristup Internetu s bilo koje eduroam lokacije. eduroam se zasniva na činjenici da se autentikacija korisnika obavlja na njegovoj matičnoj ustanovi dok se odluka o autorizaciji, odnosno pristupu mreži donosi u posjećenoj mreži.`
      },
      {
        title:
          "Mogu li studenti / znanstvenici / profesori koristiti eduroam?",
        text: `Osobe s važećim elektroničkim identitetom mogu koristiti eduroam. Matične ustanove odgovorne su za izdavanje i upravljanje korisničkim elektroničkim identitetima.`
      },
      {
        title: "Može li javni davatelj WiFi usluge pružati eduroam uslugu?",
        text: `eduroam razdvaja koncepte autentikacije (davatelji identiteta) i pristupnih točaka (davatelji usluge), čime je davanje eduroam usluge omogućeno ne samo istraživačkim i edukacijskim ustanovama, već i javnim, komercijalnim ili gradskim wifi inicijativama.<br><br>
            Komercijalne pravne osobe ne mogu postati davatelji identiteta ili nuditi usluge svojim klijentima koje će pri svom rad koristiti eduroam. Komercijalni davatelji pristupa ne smiju naplaćivati korisniku pristupanje i korištenje mreže.`
      },
      {
        title: "Kao mrežnom administratoru, što mi je sve potrebno za uspostavu eduroam usluge u svojoj ustanovi?",
        text: `Kako bi omogućili korisnicima korištenje eduroama u vašoj ustanovi potrebno je posjedovati sustav upravljanja identitetima (Identity Management System -IdMs) u kojem su pohranjeni elektronički identiteti korisnika.<br><br>
            Također potreban je RADIUS poslužitelj spojen na IdM.<br><br>
            Za uspostavu eduroam usluge u vašoj ustanovi potrebno je namjestiti bežičnu mrežu prema eduroam zahtjevima.<br><br>
            Vaša ustanova mora biti dio eduroam usluge koju pruža Nacionalni roaming operator (engl. National Roaming Operator); u većini slučajeva Nacionalna istraživačka i edukacijska mreža (National Research and Education Network - NREN)<br><br>
            Predstavnik NREN-a može vas informirati o formalnim uvjetima pristupanja eduroam usluzi.`
      },
      {
        title: "Kako funkcionira eduroam?",
        text: `Kada se korisnik pokušava spojiti na bežičnu mrežu posjećene ustanove njegov zahtjev za autentikacijom šalje se njegovoj matičnoj ustanovi putem hijerarhijskog sustava RADIUS poslužitelja. Nakon provjere korisničkih informacija matična ustanova vraća rezultat autentikacije posjećenoj ustanovi te ako je autentikacija potvrdna korisnik dobiva pristup eduroam usluzi.<br><br>
                <h3 style="color: #084776">Uzmimo za primjer korisnika koji se nalaze u prostorima SUMIT-a:</h3>
                <ol>
                    <li>Korisnik se pokušava spojiti na eduram uslugu putem prijenosnog računala / pametnog telefona / tablet. Šalje svoje vjerodajnice u kriptiranom obliku pri čemu je vidnljiva jedino ustanova kojoj pripada, npr. <b>@sum.ba</b></li>
                    <li>Preko mrežne infrastrukture kriptirane vjerodajnice dolaze do RADIUS poslužitelja koji je nadležan za WLAN u prostorima SUMIT-a.</li>
                    <li>RADIUS poslužitelj Srca provjerava sadrže li pristigle vjerodajnice oznaku ustanove za koju je on nadležan. Ako je korisnik sa oznakom @sum.ba, obavlja se proces autetikacije tog korisnika, te se njegove vjerodajnice uspoređuju se s vrijednostima pohranjenim u LDAP imeniku SUMIT-a. Vjerodajnice  korisnika koji koji ima različitu oznaku ustanove i ne spada pod RADIUS poslužitelj SUMIT-a, šalju se vršnom RADIUS poslužitelju za .ba domenu koji ih potom prosljeđuje RADIUS poslužitelju na pripadajućoj ustanovi. Nakon obavljenog procesaautetikacije korisnika uz pomoć LDAP imenika njegove ustanove, rezultat se šalje nazad do RADIUS poslužitelja SUMIT-a.</li>
                    <li>Rezultat autentikacije šalje se do WLAN uređaja.</li>
                    <li>Rezultat dolazi do krajnjeg uređaja s kojeg je započet proces autentikacije.</li>
                    <li>Ako je rezultat autentikacije potvrdan, korisniku je dozvoljen pristup Internetu i ostalim mrežnim resursima.</li>
                </ol>`
      },
      {
        title: "Koje tehnologije pogone eduroam uslugu?",
        text: `U eduroam usluzi komunikacija između pristupne točke i korisnikove matične ustanove bazirana je na IEEE 802.1x normi. Ta norma obuhvaća korištenje EAP-a (Extensible Authentication Protocol) koji omogućava korištenje različitih autentikacijskih metoda. Ako se koristi EAP-TTLS ili PEAP metoda sigurni tunel koristit će se za prijenos autentikacijskih informacija (korisničko ime/lozinka, itd.) od korisnikovog računala do njegove matične ustanove, dok se pri korištenju EAP-TLS metode obje strane autenticiraju javnim X.509 certifikatima čime je onemogućeno prisluškivanje podataka.`
      },
      {
        title: "Je li eduroam siguran za upotrebu?",
        text: `eduroam je baziran na najsigurnijim enkripcijskim i autentikacijskim normama koje trenutno postoje. Zbog toge je znatno sigurniji od tipičnih komercijalnih hotspotova. Prilikom korištenja Interneta na eduroam pristupnoj lokaciji, korisnik treba uzeti u obzir da sve sigurnosne mjere eduroam pristupne lokacije primjenjuju i na njegovu vezu s Internetom. Primjerice, postavke vatrozida na posjećenoj lokaciji mogu biti drugačije od postavki koje korisnik koristi kod kuće pa pristup do nekih internetskih usluga može biti onemogućen.`
      },
      {
        title: "Koje certifikate koristi eduroam?",
        text: `eduroam koristi poslužiteljske certifikate kako bi se prijenos korisničkih vjerodajnica obavljao kroz kriptirani tunel. Dijagram u nastavku objašnjava korake uspostave takvog kriptiranog tunela. Svaki RADIUS poslužitelj davatelja identiteta posjeduje dva certifikata: <br><br>
        <ul>
          <li>Korijenski CA self-signed (SS) certifikat - služi kao zajednička točka povjerenja između RADIUS poslužitelja i korisnika koje on autenticira. Napomena: koriste se self-signed (SS) korijenski CA certifikati zbog bug-a u Android operacijskom sustavu, koji ne podržava ulančavanje certifikata do korijenskog certifikata.</li>
          <li>RADIUS certifikat - potpisan korijenskim CA certifikatom.</li>
        </ul>
        <img src="https://web-admin.sum.ba/api/storage/eduroam_ttls_1568276902_78.png" style="width: 100%" /><br>
        <b>Pretpostavlja se da je korisnikov tablet ispravno konfiguriran za rad eduroam usluge. To znači da ima pohranjen javni dio ključa korijenskog CA certifikata davatelja identiteta.</b><br>
        <ol>
          <li>Korisnik šalje Request authentication poruku pristupnoj točki (AP).</li>
          <li>Pristupna točka odgovara s Request identity porukom.</li>
          <li>Korisnik šalje oznaku realm-a kojem pripada (npr. sum.ba) koja se koristi za usmjeravanje zahtjeva do nadležnog RADIUS poslužitelja.</li>
          <li>Poslužitelj šalje svoj RADIUS certifikat koji je potpisan s tajnim ključem korijenskog CA.</li>
          <li>Korisnik prima RADIUS certifikat poslužitelja te provjerava njegov digitalni potpis korištenjem javnog dijela ključa korijenskog CA. Ako je provjera potpisa dala pozitivan ishod, korisnik zna da se radi o vjerodostojnom certifikatu.</li>
          <li>Korisnik koristi javni dio ključa RADIUS certifikata kako bi kriptirao podatke potrebne za uspostavu sigurnog tunela (engl. pre shared secret).</li>
          <li>Poslužitelj dekriptira primljene podatke s privatnim dijelom RADIUS certifikata.</li>
          <li>Temeljem unaprijed dijeljene tajne, RADIUS poslužitelj generira potrebne podatke za uspostavu kriptiranog TLS tunela.</li>
          <li>Korisnik šalje svoje vjerodajnice kroz kriptirani TLS tunel.</li>
        </ol><br><br>
        Iz opisanih koraka moguće je zaključiti kako izmjena RADIUS certifikata nema utjecaja na krajnje korisnike sve dok je novi certifikat potpisan od strane istog korijenskog CA certifikata. U slučaju da je certifikat istekao ili postoji sumnja da je vjerodostojnost certifikata narušena, ovime je omogućeno ponovno generiranje certifikata od strane eduroam administratora.<br><br>
        Korisnici moraju ponovno konfigurirati svoje uređaje samo u slučaju promjene korijenskoga CA certifikata poslužitelja.<br><br>`
      },
      {
        title: "Koristi li eduroam captive portal za autentikaciju?",
        text: `Ne. Autentikacijski mehanizmi koji koriste web portale, captive portale te splash prikaze nisu sigurni načini za prihvati eduroam oznaka, čak i ako je veza zaštićena HTTPS protokolom. Zbog raspodijeljene prirode eduroam usluge bio bi potreban velik broj različitih stranica za autentikaciju na različitim jezicima što bi dodatno otežalo raspoznavanje stvarnih eduroam stranica od malicioznih. I u slučaju da postoji konzistentan dizajn stranica za autentikaciju, napadač bi ga mogao preuzeti i prikazati na malicioznoj stranici.<br><br>
                eduroam zahtijeva poštivanje 802.1x norme koja pruža enkripciju s kraja na kraj. Na taj način privatne korisničke oznake zaštićene su tijekom prijenosa i dostupne su samo vašoj matičnoj ustanovi. Jedina stavka kojoj korisnik mora vjerovati jest certifikat njegove matične ustanove bez obzira na infrastrukturu koja se nalazi između njega i matične ustanove. Web portali zahtijevaju od korisnika da vjeruju infrastrukturi kojom putuje korisnička oznaka jer nema kriptiranja s kraja na kraj te time krše osnovne odrednice sigurnosti eduroam sustava.`
      },
      {
        title: "Radi li eduroam na različitim platformama?",
        text: `eduroam koristi otvorene standarde kako bi omogući pristup jednolik pristup različitim platformama. Dakle, eduroam je moguće koristiti na Windows, Linux, MacOS, iOS te Android operacijskim sustavima.`
      },
      {
        title:
          "Tko je odgovoran za podršku krajnjim korisnicima?",
        text: `Informatički odjel svake matične ustanove odgovoran je za svoje eduroam krajnje korisnike. Konfiguracija klijentskih uređaja za spajanje na eduroam znatno je pojednostavljena eduroam installer alatom kojeg pruža SUMIT, čime je smanjen i olakšan potreban rad informatičkog odjela.`
      },
      {
          title: 'Spajanje nije moguće, iako je preuzet softver za Windows 8 operacijski sustav sa installer alata',
          text: `Uzrok problema je u poslužiteljskom certifikatu koji služi za zatvaranje TLS tunela pri spajanju. Trenutni poslužiteljski certifikat nema odsječak koji govori Windows 8 operacijskim sustavima da se radi upravo o certifikatu namijenjenom za EAP-TLS te ga zato odbijaju. Detaljan opis problema nalazi se na <a href="https://support.microsoft.com/en-us/help/814394/certificate-requirements-when-you-use-eap-tls-or-peap-with-eap-tls" target="_blank" class="link">linku</a>.<br><br>
            Generiranje novog poslužiteljskog certifikata rješava ovaj problem. Napomena: rootCA certifikat RADIUS poslužitelja ostat će nepromijenjen tako da korisnici neće morati rekonfigurirati svoje uređaje za pristup eduroam usluzi.`
      }
    ]
  }),
  methods: {
    active(data) {
      this.active_num = data;
    }
  }
};
</script>
